import * as React from "react";
import Svg, { SvgProps, G, Path, Defs, ClipPath } from "react-native-svg";
const MoneyCheck = (props: SvgProps) => (
  <Svg width={32} height={32} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        fill="#090A0A"
        stroke="#090A0A"
        strokeWidth={0.6}
        d="M32 6v7.37a7.005 7.005 0 0 0-1.333-.791V6c0-1.103-.898-2-2-2H3.333c-1.102 0-2 .897-2 2v22H12v1.333H0V6a3.337 3.337 0 0 1 3.333-3.333h25.334A3.337 3.337 0 0 1 32 6Zm-4 3.333H17.333v1.334H28V9.333Zm3.024 6.31c.63.63.976 1.466.976 2.357 0 .89-.347 1.728-.976 2.357L19.381 32h-4.713v-4.715l11.643-11.642a3.336 3.336 0 0 1 4.713 0ZM30.667 18a2.001 2.001 0 0 0-3.413-1.415L16 27.837v2.83h2.828l11.252-11.252c.378-.378.586-.88.586-1.415ZM10 9.333h-.667V6.667H8v2.666h-.667A3.337 3.337 0 0 0 4 12.667a3.782 3.782 0 0 0 3.083 3.714l2.921.548a2.447 2.447 0 0 1 1.995 2.404c0 1.103-.898 2-2 2H7.332c-1.103 0-2-.897-2-2v-.666H3.999v.666a3.337 3.337 0 0 0 3.333 3.334h.667v2.666h1.333v-2.666h.667a3.337 3.337 0 0 0 3.333-3.334 3.782 3.782 0 0 0-3.084-3.714l-2.921-.548a2.447 2.447 0 0 1-1.995-2.404c0-1.103.897-2 2-2h2.667c1.102 0 2 .897 2 2v.666h1.333v-.666A3.336 3.336 0 0 0 10 9.333ZM17.333 16h4.85l1.333-1.333h-6.183V16Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default MoneyCheck;
